export default [
  {
    path: '/b2bhub/Home',
    name: 'dashboard-ptc',
    component: () => import('@/views/app/PTC/DashBoard/dashboard.vue'),
    meta: {
      pageTitle: 'Dashboard',
      action: 'read',
      resource: 'Acesso_Dashboard',
    },

  },
];
